
const DistributionChart = () => {
  return (
    <section>
      <div className="fw-semibold fs-4 my-3">Distribution Charts</div>

      <div className="text-center bg-white rounded py-3">
        <div className="fw-semibold">Campaign Performance Distribution</div>
        <div className="p-5">Pie/Bar Chart</div>
      </div>

    </section>
  )
}

export default DistributionChart
